// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".changelogs-preview .splide__pagination__page.is-active{--tw-bg-opacity:1;background-color:#263b97}@supports (color:rgb(0 0 0/0)) and (top:var(--f )){.changelogs-preview .splide__pagination__page.is-active{background-color:rgb(38 59 151/var(--tw-bg-opacity))}}.changelogs-preview .splide__pagination{bottom:-1.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
